import { AxiosInstance, AxiosError } from "axios";
import { IErrorData } from "../services/types";
import { useCaptchaStore } from "../store/captchaStore";

const STATUS_RATE_LIMITED = 429;

export const attachCaptchaInterceptor = (client: AxiosInstance) => {
  client.interceptors.response.use(
    res => res,
    async (err: AxiosError<IErrorData>) => {
      if (
        err.response?.status === STATUS_RATE_LIMITED &&
        err.response.data?.error
      ) {
        const subject = err.response.data.error?.subject;

        if (subject) {
          const token = await useCaptchaStore.getState().solve(subject);
          await client.post("v2/auth/rate-limit", { subject, captcha: token });
          return client.request(err.config);
        }
      }
      return Promise.reject(err);
    }
  );
};
